<template>
	<div class="sidebar" v-if="sidebarInfo">
		<div class="mod_title">
			<span class="title">{{ modTitle }}</span>
		</div>
		<div class="mod_menu">
			<ul class="menu_list">
				<li v-show="!menu.isShow" :class="getActive(menu.name) ? 'active' : ''" v-for="menu of menuList" :key="menu.menuId" @click="$router.push({ name: menu.url })">
					{{ menu.name }}
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		sidebarInfo: Object,
	},
	computed: {
		modTitle() {
			return this.sidebarInfo['name']
		},
		menuList() {
			return this.sidebarInfo['children']
		},
	},
	created() {
		// console.log(this.$route.query.code, 'this.$route.query.code')
		// console.log(this.$route.query.routeName, 'routeNamerouteName')
	},
	methods: {
		getActive(name) {
			// let code = this.$route.query.code
			// let routeName = this.$route.query.routeName
			// if (code && this.$route.name == 'allequpt') return
			// if (routeName == 'wtsj' && this.$route.name == 'allequpt') return
			let b = false
			this.$route.matched.forEach(item => {
				if (item.meta.title.split('-')[0] == name) {
					b = true
				}
			})
			return b
		},
	},
}
</script>

<style lang="scss" scoped>
.sidebar {
	width: 208px;
	background: #fff;
	// height: calc(100vh - 320px);
	min-height: calc(100vh - 168px);
	margin-top: 16px;
	margin-bottom: 16px;
	box-shadow: 0px 2px 24px 1px rgba(0, 0, 0, 0.06);
	border-radius: 16px;
	.mod_title {
		padding: 14px 16px;
		border-bottom: 1px solid #dcdcdc66;
		.title {
			padding-left: 14px;
			font-size: 16px;
			font-weight: bold;
			color: #2962b0;
			border-left: 2px solid #2962b0;
		}
	}
	.mod_menu {
		padding: 16px;
		.menu_list {
			li {
				height: 40px;
				line-height: 40px;
				text-align: center;
				margin-bottom: 8px;
				background: rgba(51, 51, 51, 0.04);
				font-size: 16px;
				font-weight: bold;
				color: #333;
				border-radius: 8px;
				cursor: pointer;
				&:hover {
					background: #eff7ff;
					color: #2962b0;
				}
				&.active {
					background: #eff7ff;
					color: #2962b0;
				}
			}
		}
	}
}
</style>
